// banner offer
import off15Image from '/public/images/plans/off15.webp'
import off30Image from '/public/images/plans/off30.webp'
import off20Image from '/public/images/plans/off20.webp'
import off33Image from '/public/images/plans/off33.webp'
import off28Image from '/public/images/plans/off28.webp'
import off55Image from '/public/images/plans/off55.webp'
import off60Image from '/public/images/plans/off60.webp'

export const PLANS = {
  play: [
    {
      id: 'm1xitw6v',
      name: 'Foguete Play - Anual',
      planType: 'Anual',
      installmentCount: 12,
      installmentAmount: 29.9,
      recommended: false,
      off: off60Image,
      price: 358.8,
      type: 'play',
      title: 'Plano Anual - 58% OFF',
      priceWithoutDiscount: 838.8,
      benefits: (
        <>
          <li>Mude seu corpo e sua vida</li>
          <li>Economize R$ 480,00</li>
        </>
      )
    },
    {
      id: 'e8ix45w5',
      name: 'Foguete Play - Semestral',
      planType: 'Semestral',
      installmentCount: 6,
      installmentAmount: 49.9,
      recommended: false,
      off: off30Image,
      price: 299.4,
      type: 'play',
      title: 'Plano Semestral - 30% OFF',
      priceWithoutDiscount: 419.4,
      benefits: (
        <>
          <li>Conquiste o seu corpo perfeito</li>
          <li>Economize R$ 120,00</li>
        </>
      )
    },

    {
      id: '732y2pz9',
      name: 'Foguete Play - Trimestral',
      planType: 'Trimestral',
      installmentCount: 3,
      installmentAmount: 69.9,
      recommended: false,
      price: 209.7,
      type: 'play',
      title: 'Plano Trimestral',
      priceWithoutDiscount: 478.8,
      benefits: (
        <>
          <li>Resultados visíveis no seu corpo</li>
          <li>Flexibilidade para continuar quando quiser</li>
        </>
      )
    }
  ],
  live: [
    {
      id: 'ceoatr7i',
      name: 'Foguete Play + Ao Vivo - Anual',
      planType: 'Anual',
      installmentCount: 12,
      installmentAmount: 39.8,
      recommended: true,
      off: off55Image,
      price: 477.6,
      type: 'live',
      title: 'Plano Anual - 50% OFF',
      priceWithoutDiscount: 957.6,
      benefits: (
        <>
          <li>Mude seu corpo e sua vida</li>
          <li>Economize R$ 480,00</li>
        </>
      )
    },
    {
      id: 'kms5gqhp',
      name: 'Foguete Play + Ao Vivo - Semestral',
      planType: 'Semestral',
      installmentCount: 6,
      installmentAmount: 59.8,
      recommended: false,
      off: off33Image,
      price: 358.8,
      type: 'live',
      title: 'Plano Semestral - 25% OFF',
      priceWithoutDiscount: 478.8,
      benefits: (
        <>
          <li>Conquiste o seu corpo perfeito</li>
          <li>Economize R$ 120,00</li>
        </>
      )
    },
    {
      id: 'dbojowfw',
      name: 'Foguete Play + Ao Vivo - Trimestral',
      planType: 'Trimestral',
      installmentAmount: 79.8,
      installmentCount: 3,
      recommended: false,
      price: 239.4,
      type: 'live',
      title: 'Plano Trimestral',
      benefits: (
        <>
          <li>Resultados visíveis no seu corpo</li>
          <li>Flexibilidade para continuar quando quiser</li>
        </>
      )
    }
  ]
}

export const SELECT_OPTION_MAPPER = {
  'Aulas Ao Vivo + Gravadas': 'live',
  'Aulas Gravadas': 'play'
}

export const SELECT_OPTIONS = [
  {
    label: 'Aulas Ao Vivo + Gravadas',
    value: 'Aulas Ao Vivo + Gravadas',
    productId: 'live'
  },
  { label: 'Aulas Gravadas', value: 'Aulas Gravadas', productId: 'play' }
]
